import { Link } from 'react-router-dom';
import styled from 'styled-components';

interface DotProps {
  bgColor: string;
}

interface GradeCheck {
  grade: boolean;
}

export const SubMenuItemHeader = styled(Link)`
  display: flex;
  align-items: center;
  font-size: 0.875rem;
  font-weight: 600;
  line-height: 2.5;
  letter-spacing: 0.5px;
  opacity: 1;
  color: var(--white);
  &:hover {
    color: var(--white);
  }
  &.disabled {
    pointer-events: none;
  }
`;

export const Dot = styled.div<DotProps>`
  height: 0.75rem;
  min-width: 0.75rem;
  border-radius: 0.38rem;
  background-color: ${(props) => props.bgColor};
  margin-right: 1rem;
`;

export const SubMenuItemGrade = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  border: solid 1px white;
  max-height: 30px;
  width: 40px;
  font-size: 12px;
  left: 135px;
  color: var(--white);
`;

export const SubMenuItemTitle = styled.div<GradeCheck>`
  text-align: left;
  width: ${(props) => (props.grade ? '100%' : '140px')};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: var(--white);
`;

export const SubMenuItemLi = styled.li`
  display: flex;
  flex-direction: row;
  padding-left: 0;
  justify-content: space-between;
  color: var(--white);
  &.disabled {
    cursor: not-allowed;
  }
`;

export const Title = styled.span<{ isTeiaHeader?: boolean }>`
  text-align: left;
  width: 170px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-color: ${(props) => props.isTeiaHeader ? '#ffff' : '#5F2AB2'}
  &:focus {
    color: ${(props) => props.isTeiaHeader ? '#ffff' : '#5F2AB2'}
  }
`;
